import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { RoleFilterEntity } from '../../domain/entities/RoleFilterEntity'

export class RoleFilterModel extends RoleFilterEntity {
  createdAtFrom?: string
  createdAtTo?: string
  constructor(dataDto: RoleFilterEntity) {
    super()
    mapEntityProperties<RoleFilterModel>(this, dataDto, {
      exclude: ['date'],
      map: {
        createdAtFrom: dataDto.date ? dataDto.date[0] : undefined,
        createdAtTo: dataDto.date ? dataDto.date[1] : undefined,
        }
    })
  }
}
